import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cookie-info-modal",
    role: "dialog",
    "aria-labelledby": "cookie-info-title",
    "aria-modal": "true"
};
const _hoisted_2 = { class: "cookie-info-content" };
const _hoisted_3 = { class: "cookie-info-header" };
const _hoisted_4 = { class: "cookie-info-header-left" };
const _hoisted_5 = {
    id: "cookie-info-title",
    class: "cookie-info-title"
};
const _hoisted_6 = { class: "cookie-info-body" };
const _hoisted_7 = { class: "cookie-info-text" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'CookieInfoModal',
    props: {
        visible: { type: Boolean },
        t: {}
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const onClose = () => {
            emit('close');
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
                default: _withCtx(() => [
                    (__props.visible)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", {
                                class: "cookie-info-overlay",
                                onClick: onClose
                            }),
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, [
                                        _createElementVNode("h2", _hoisted_5, _toDisplayString(__props.t?.cookieInfo?.title || 'About Cookies'), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "cookie-info-close",
                                        onClick: onClose,
                                        "aria-label": "Close cookie information"
                                    }, [...(_cache[0] || (_cache[0] = [
                                            _createElementVNode("svg", {
                                                viewBox: "0 0 24 24",
                                                fill: "none"
                                            }, [
                                                _createElementVNode("path", {
                                                    d: "M18 6L6 18M6 6L18 18",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    "stroke-linecap": "round"
                                                })
                                            ], -1)
                                        ]))])
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(__props.t?.cookieInfo?.whatAreCookies || 'Cookies are small text files that are placed on your device when you visit a website.'), 1)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _: 1
            }));
        };
    }
});
